import { createContext } from 'react';
import { noop } from 'lodash';

export const WebSocketContext = createContext({
    sendMessage: noop,
    onMessage: noop,
    connected: false,
});
